import { ComponentProps, forwardRef } from 'react'

type LabelProps = ComponentProps<'label'> & {
  required?: boolean
}

const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ required = false, children, className, ...rest }: LabelProps, ref) => {
    return (
      <label ref={ref} className={`block text-sm font-semibold leading-6 text-zinc-900 ${className}`} {...rest}>
        <span>{children}</span>
        {required && <span className="ml-1 text-red-500">*</span>}
      </label>
    )
  }
)

Label.displayName = 'Label'

export default Label
